(() => {
  'use strict';

  const initializeCatalog = (catalog) => {
    if (catalog.dataset.nvV9Ready === 'true') return;
    const filters = catalog.querySelector('[data-nv-v9-filters]');
    const buttons = Array.from(catalog.querySelectorAll('[data-nv-v9-filter]'));
    const cards = Array.from(catalog.querySelectorAll('[data-nv-v9-kind]'));
    const count = catalog.querySelector('[data-nv-v9-count]');
    if (!filters || !buttons.length || !cards.length || !count) return;

    const allowedFilters = new Set(buttons.map((button) => button.dataset.nvV9Filter));
    const selectedFromHash = () => {
      const key = window.location.hash.slice(1);
      return allowedFilters.has(key) ? key : 'all';
    };
    const applyFilter = (key) => {
      let visibleCount = 0;
      cards.forEach((card) => {
        const visible = key === 'all'
          ? card.dataset.nvV9Kind === 'single'
          : card.dataset.nvV9Series === key;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.nvV9Filter === key));
      });
      count.textContent = count.dataset.nvV9CountTemplate.replace('__COUNT__', String(visibleCount));
      catalog.dataset.nvV9ActiveFilter = key;
    };

    filters.addEventListener('click', (event) => {
      const button = event.target.closest('[data-nv-v9-filter]');
      if (!button || !filters.contains(button)) return;
      const key = button.dataset.nvV9Filter;
      if (!allowedFilters.has(key)) return;
      applyFilter(key);
      if (window.location.hash !== `#${key}`) {
        window.history.pushState(null, '', `#${key}`);
      }
    });
    window.addEventListener('hashchange', () => applyFilter(selectedFromHash()));
    window.addEventListener('popstate', () => applyFilter(selectedFromHash()));
    catalog.dataset.nvV9Ready = 'true';
    applyFilter(selectedFromHash());
    filters.hidden = false;
  };

  const initialize = (scope = document) => {
    if (scope.matches?.('[data-nv-v9-catalog]')) initializeCatalog(scope);
    scope.querySelectorAll('[data-nv-v9-catalog]').forEach(initializeCatalog);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
